/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_M_Create_DescInputs */

const es_nav_m_create_desc = /** @type {(inputs: Nav_M_Create_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regístrate en Zarpar`)
};

const gl_nav_m_create_desc = /** @type {(inputs: Nav_M_Create_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rexístrate en Zarpar`)
};

const en_nav_m_create_desc = /** @type {(inputs: Nav_M_Create_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign up for Zarpar`)
};

/**
* | output |
* | --- |
* | "Sign up for Zarpar" |
*
* @param {Nav_M_Create_DescInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_m_create_desc = /** @type {((inputs?: Nav_M_Create_DescInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_M_Create_DescInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_nav_m_create_desc(inputs)
	if (locale === "en") return en_nav_m_create_desc(inputs)
	return es_nav_m_create_desc(inputs)
});